<template>
    <main class="productFeature" :data-mui-theme="data?.data.theme">
        <SliceZone :components="components" :slices="slices" />
    </main>
</template>

<script setup lang="ts">
    import {type PrismicDocument} from '@prismicio/types';
    import {SliceZone} from '@prismicio/vue';
    import {definePageMeta, useWebsitePageView, useAsyncData, createError} from '#imports';
    import {useRoute} from '#imports';
    import {useFeatureFlag} from '@malt/feature-flags';
    import {usePrismicDocument} from '~/composables/content/usePrismicDocument';
    import {useABTestSlices} from '~/composables/useABTestSlices';
    import {useDefineSeoAndMetaTags} from '~/composables/useDefineSeoAndMetaTags';
    import {components} from '~/slices/components';

    definePageMeta({
        validate: (): boolean => useFeatureFlag('new-platform-page').value,
    });

    const route = useRoute();

    const {fetchDocument} = usePrismicDocument('productFeature', route.params.uid as string);
    const {data, error} = await useAsyncData<PrismicDocument>('productFeature-' + route.params.uid, () => fetchDocument());
    if (error.value) {
        throw createError(error.value);
    }

    const {slices} = useABTestSlices(data.value!);

    useDefineSeoAndMetaTags(data.value!);
    useWebsitePageView('cms', 'product-feature');
</script>
